import React from "react";

/**
 * Pastel rose-gold ring — pure CSS / SVG.
 * Replaces the previous R3F Canvas to avoid dev-mode reconciler errors and
 * keeps the hero light, fast and accessible. Animates gently on a soft glow.
 */
export default function ThreeRing() {
  return (
    <div className="w-full h-full flex items-center justify-center" data-testid="three-ring-canvas">
      <div className="relative w-72 h-72 md:w-[420px] md:h-[420px]">
        <div
          className="absolute inset-0 rounded-full blur-3xl opacity-60"
          style={{ background: "radial-gradient(circle at 50% 45%, rgba(212,168,142,0.55), rgba(200,210,189,0.25) 45%, transparent 70%)" }}
        />
        <svg
          viewBox="0 0 200 200"
          className="absolute inset-0 w-full h-full"
          style={{ animation: "bv-spin 22s linear infinite", filter: "drop-shadow(0 12px 30px rgba(181,137,110,0.25))" }}
          aria-hidden
        >
          <defs>
            <linearGradient id="ringMain" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#D4A88E" />
              <stop offset="50%" stopColor="#B5896E" />
              <stop offset="100%" stopColor="#E8C4AC" />
            </linearGradient>
            <linearGradient id="ringInner" x1="0" y1="1" x2="1" y2="0">
              <stop offset="0%" stopColor="#E8C4AC" />
              <stop offset="100%" stopColor="#FAF6F0" />
            </linearGradient>
            <radialGradient id="stone" cx="0.5" cy="0.4" r="0.6">
              <stop offset="0%" stopColor="#FFFFFF" />
              <stop offset="40%" stopColor="#F4E8DC" />
              <stop offset="100%" stopColor="#D4A88E" />
            </radialGradient>
          </defs>
          <circle cx="100" cy="100" r="62" fill="none" stroke="url(#ringMain)" strokeWidth="22" />
          <circle cx="100" cy="100" r="62" fill="none" stroke="url(#ringInner)" strokeWidth="3" opacity="0.9" />
          <circle cx="100" cy="32" r="10" fill="url(#stone)" />
          <circle cx="100" cy="32" r="10" fill="none" stroke="#B5896E" strokeWidth="1" opacity="0.8" />
          <circle cx="100" cy="29" r="3" fill="#FFFFFF" opacity="0.85" />
        </svg>
        <div
          className="absolute inset-12 rounded-full"
          style={{
            border: "1px solid rgba(181,137,110,0.18)",
            animation: "bv-spin 30s linear infinite reverse",
          }}
        />
        <style>{`@keyframes bv-spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
